export default __webpack_public_path__ + "static/media/Shocker_HTB.24bcc0de.md";